module.exports = __webpack_public_path__ + "media/images/nn_logo_big-e23925394c4815d00cb8a160e71d1233.svg";